import { Card, Skeleton } from '@/components/ui';

export function RecentFixturesSkeleton() {
  return (
    <Card noPadding className="overflow-hidden shadow-sm">
      <div className="divide-y divide-gray-100 dark:divide-dark-700">
        {Array.from({ length: 5 }).map((_, i) => (
          <div key={i} className="px-3 py-3 sm:px-4">
            <Skeleton className="h-16 w-full rounded-md sm:h-[4.5rem]" />
          </div>
        ))}
      </div>
    </Card>
  );
}
